<template>
  <el-dialog
    title="維養登記表單 QRCode"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div class="subtitle">
      請選擇維養廠商
    </div>
    <el-select
      v-model="selectSupplier"
      placeholder="請選擇"
    >
      <el-option
        v-for="item in supplierList"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
    <div class="button-container">
      <el-button @click="handleClose">
        取消
      </el-button>
      <el-button
        type="primary"
        :disabled="isDisable"
        @click="handleSubmit"
      >
        確定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    supplierList: {
      type: Array
    }
  },
  data () {
    return {
      dialogVisible: false,
      isLoading: false,
      selectSupplier: null
    }
  },
  computed: {
    isDisable () {
      // 沒有選擇的話就不可送出
      return !this.selectSupplier
    }
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
      this.selectSupplier = null
    },
    handleSubmit () {
      this.$emit('selectSupplier', this.selectSupplier)
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  @include basicDialog();
  .el-dialog__body{
    display: flex;
    flex-direction: column;
    gap: 20px;
    .subtitle{
      align-self: start;
    }
  }
}
</style>
